'use client';

import * as React from 'react';
import { format } from 'date-fns';
import { CalendarIcon } from 'lucide-react';

import { cn } from '@/lib/utils';
import { isValidPackageDate } from '@/utils/packageAvailabilityCalendar';

interface ReadOnlyDateDisplayProps {
  value?: Date;
  className?: string;
  placeholder?: string;
}

export function ReadOnlyDateDisplay({
  value,
  className,
  placeholder = 'Pick a date',
}: ReadOnlyDateDisplayProps) {
  const isValidValue = value != null && isValidPackageDate(value);

  return (
    <div
      className={cn(
        'border-input flex h-10 w-full items-center gap-2 rounded-sm border border-secondary bg-muted/40 px-3 text-sm text-muted-foreground cursor-default select-none',
        className
      )}
      aria-readonly
    >
      <CalendarIcon className='h-4 w-4 flex-shrink-0 opacity-50' />
      <span className={cn(isValidValue && 'text-foreground')}>
        {isValidValue ? format(value, 'EEE dd MMM, yyyy') : placeholder}
      </span>
    </div>
  );
}
